import React, { useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@material-ui/core";
import {
  KeyboardArrowUp,
  KeyboardArrowDown,
  RemoveCircleOutline,
} from "@material-ui/icons";
import { toast } from "react-toastify";
import * as dateFNS from 'date-fns';

import { producaov2 } from "../../../../../services/apis";
import { ClampedText } from "./styles";
import CreateAccessBlockingModal from "../CreateAccessBlockingModal";

function Row({ accessBlocking, refreshData = () => {} }) {
  const [open, setOpen] = useState(false);
  const [removedReasonIDs, setRemovedReasonIDs] = useState([]);

  const handleRemoveBlockingReason = async (reasonID) => {
    try {
      setRemovedReasonIDs((prev) => [...prev, reasonID]);

      await producaov2.delete(`/admin/access-blocking`, {
        params: {
          userID: accessBlocking.id_pessoa,
          courseID: accessBlocking.id_curso,
          reasonID,
        },
      });

      toast.success("Motivo de bloqueio removido com sucesso");
    } catch (error) {
      setRemovedReasonIDs((prev) => prev.filter((id) => id !== reasonID));
      toast.error(`Erro ao remover o motivo de bloqueio ${accessBlocking?.id}`);
    }
  };

  if (accessBlocking?.reasons?.length === removedReasonIDs.length) {
    return null;
  }

  return (
    <>
      <TableRow>
        <TableCell>
          <IconButton size="small" onClick={() => setOpen((prev) => !prev)}>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{accessBlocking?.id}</TableCell>
        <TableCell>
          <a
            href={`/admin/alunos/detalhes/${accessBlocking?.pessoa?.id}`}
            target="_blank"
            style={{ color: "#000" }}
            title={accessBlocking?.pessoa?.nome}
          >
            <ClampedText maxWidth="20vw">
              {`[${accessBlocking?.pessoa?.id}] ${accessBlocking?.pessoa?.nome}`}
            </ClampedText>
          </a>
        </TableCell>
        <TableCell>
          <a
            href={`/admin/cursos/conteudo?search=${accessBlocking?.curso?.curso}`}
            target="_blank"
            style={{ color: "#000" }}
            title={accessBlocking?.curso?.curso}
          >
            <ClampedText>
              {`[${accessBlocking?.curso?.id}] ${accessBlocking?.curso?.curso}`}
            </ClampedText>
          </a>
        </TableCell>
        <TableCell>{dateFNS.format(new Date(accessBlocking?.created_at), 'dd/MM/yyyy')}</TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={5}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Motivos de bloqueio
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Motivo</TableCell>
                    <TableCell>Mensagem</TableCell>
                    <TableCell>Adicionado em</TableCell>
                    <TableCell />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {accessBlocking?.reasons?.map((reason) => {
                    if (removedReasonIDs?.includes(reason?.id_reason)) {
                      return null;
                    }

                    return (
                      <TableRow>
                        <TableCell>{reason?.reason?.name}</TableCell>
                        <TableCell>{reason?.message}</TableCell>
                        <TableCell>{reason?.created_at}</TableCell>
                        <TableCell>
                          <IconButton
                            onClick={() =>
                              handleRemoveBlockingReason(reason?.id_reason)
                            }
                            size="small"
                            title="Remover motivo de bloqueio"
                          >
                            <RemoveCircleOutline htmlColor="#ff0000" />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

export default function AccessBlockingsList({
  accessBlockings,
  limit,
  page,
  loading,
  changeLimit,
  nextPage,
  prevPage,
  refreshData,
  changePage,
}) {
  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>ID</TableCell>
              <TableCell>Aluno</TableCell>
              <TableCell>Curso</TableCell>
              <TableCell>Bloqueado em</TableCell>
            </TableRow>
          </TableHead>
          {loading && (
            <TableBody>
              {Array(limit).fill(0).map((_, index) => (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Box height={12} bgcolor="#eee" width="100%" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
          {!loading && (
            <TableBody>
              {accessBlockings?.data?.map((accessBlocking) => {
                return (
                  <Row key={accessBlocking?.id} accessBlocking={accessBlocking} />
                );
              })}
            </TableBody>
          )}
        </Table>
        {accessBlockings?.paging && (
          <TablePagination
            component="div"
            rowsPerPageOptions={[10, 25, 50, 100]}
            count={accessBlockings?.paging?.total}
            rowsPerPage={limit}
            page={page - 1}
            onChangePage={(_, page) => changePage(page + 1)}
            onChangeRowsPerPage={(e) => changeLimit(e.target.value)}
          />
        )}
      </TableContainer>
    </>
  );
}
